import { TLNRChampion, TLNRChampionServer } from '../models'

export const mapToServer = (payload: TLNRChampion): Omit<TLNRChampionServer, 'EntryId'> => ({
  Email: payload.Email.trim().toLowerCase(),
  FirstName: payload.FirstName.trim(),
  LastName: payload.LastName.trim(),
  JobTitle: payload.JobTitle.trim(),
  RequestId: payload.RequestId,
  WorkPhone: payload.WorkPhone.trim(),
  WorkPhone_Prefix: payload.WorkPhone_Prefix.trim(),
  MobilePhone: payload.MobilePhone ? payload.MobilePhone.trim() : null,
  MobilePhone_Prefix: payload.MobilePhone_Prefix ? payload.MobilePhone_Prefix.trim() : null,
})
